//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionBase, Paper } from '@backmarket/design-system'

export default {
  components: {
    ActionBase,
    Paper,
  },

  props: {
    link: {
      type: Object,
      required: true,
    },
  },

  computed: {
    productCardClass() {
      return this.$slots.footer ? 'pb-6' : 'pb-7 md:h-[35.8rem]'
    },
  },
}
